import { ordersAPI } from '~/services/api';
import { WEB_ORDERS_API } from '~/services/web-orders.service';
import { type CreateReturnLabelBatchEntry } from '~/types/APIReturnLabels';

/**
 * Service function to create a batch entry for a return label
 * @param {CreateReturnLabelBatchEntryParams} { orderID, batchEntryId? }
 * @returns
 */
export const createReturnLabelExternallyFulfilled: CreateReturnLabelBatchEntry = (
  orderId,
  batchEntryId,
) =>
  ordersAPI.request({
    method: 'POST',
    url: `${WEB_ORDERS_API}/${orderId}/return`,
    ...(batchEntryId && {
      data: {
        shipment: batchEntryId,
      },
    }),
  });
